import { ListFacetBase } from '@mp/shared/facets/domain';
import { SupplierType } from '@mpsm/shared/domain';

type SupplierBucket = ListFacetBase.Bucket<{ type: SupplierType }>;

export type SupplierFacetIconSelectorFn = (bucket: SupplierBucket) => string;

export const supplierFacetIconSelector: SupplierFacetIconSelectorFn = (bucket: SupplierBucket): string => {
  return bucket.additionalData.type === SupplierType.ClinicSupplier ? '@transport_clinic' : 'local_shipping';
};
